export default __webpack_public_path__ + "static/6-980b0803b046cfecaf4cb42d00f7e6ec.jpg";